// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductTag_root__Nxivt","name":"ProductTag_name__C_niq","fontsizing":"ProductTag_fontsizing__XnIPn","price":"ProductTag_price__RDK06"};